import { UserInfoService } from './../../../services/userInfo.service';
import { AlertDesignOnebuttonComponent } from './../../alert-design-onebutton/alert-design-onebutton.component';
import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { AlertDesignComponent } from 'src/app/pages/alert-design/alert-design.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router, Event as NavigationEvent, NavigationStart, NavigationEnd } from '@angular/router';
import { Validator } from '../../../validator';
import { AuthService } from 'src/app/services/auth.service';
import { DbService } from 'src/app/services/db.service';
import { take, filter } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.css'],
})
export class LoginSignupComponent implements OnInit {
  year = 'placeholder';
  area = 'placeholder';
  emailadd = 'placeholder';
  uid;
  schoolYear = ['1학년', '2학년', '3학년', '4학년', '5학년', '6학년'];

  schoolArea = [
    '서울특별시',
    '세종특별자치시',
    '인천광역시',
    '대전광역시',
    '광주광역시',
    '대구광역시',
    '울산광역시',
    '부산광역시',
    '경기도',
    '강원도',
    '충청북도',
    '충청남도',
    '경상북도',
    '경상남도',
    '전라북도',
    '전라남도',
    '제주도',
  ];

  emailArray = [
    'naver.com',
    'hanmail.net',
    'nate.com',
    'gmail.com',
    '직접입력',
  ];

  // 이메일
  public emailAddress = {
    emailid: '',
    emailaddr: '',
    emailaddr2: '',
  };

  // 여기서부터
  public oneMoreCheckId;
  public alreadyId = false;
  public idChecked = false;
  public agreeAllTerms = false;
  public form: FormGroup;


  previousUrl$;
  currentUrl$;

  public account = {
    studentId: '',
    id: '',
    password: '',
    confirmPassword: '',
    exitSwitch: false,
    serviceTerms: false,
    personalInfo: false,
    teacherCode: '',
    name: '',
    gender: '',
    region: 'placeholder',
    grade: 'placeholder',
    school: '',
    cardlistH: [],
    groupPlaySwitch: false,
    allPlayFeed: [],
    type: 'student',
  };

  constructor(
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dbService: DbService,
    private spinner: NgxSpinnerService,
    public location: Location,
    public userinfo: UserInfoService
  ) {

    this.userinfo.userInfo.subscribe((info: any) => {
      console.log('Info', info);
      if (info) {
        if (info.id) {
          this.idChecked = true;
        }
        this.account.studentId = info.studentId;
        this.account.id = info.id;
        this.account.exitSwitch = info.exitSwitch;
        this.account.serviceTerms = info.serviceTerms;
        this.account.personalInfo = info.personalInfo;
        this.account.teacherCode = info.teacherCode;
        this.account.name = info.name;
        this.account.gender = info.gender;
        this.account.region = info.region;
        this.account.school = info.school;
        this.account.grade = info.grade;
        this.account.cardlistH = info.cardlistH;
        this.account.groupPlaySwitch = info.groupPlaySwitch;
        this.account.allPlayFeed = info.allPlayFeed;
        this.account.type = info.type;
      }
    })


    this.form = formBuilder.group(
      {
        id: Validator.idValidator,
        password: Validator.passwordValidator,
        confirmPassword: Validator.confirm_passwordValidator,
        serviceTerms: Validator.serviceTermsValidator,
        personalInfo: Validator.personalInfoValidator,
        name: Validator.nameValidator,
      },
      { validators: this.matchingPasswords('password', 'confirmPassword') }
    );
  }

  ngOnInit(): void {
    console.log('ngOnInit');

    $(function () {
      //id 포커스
      $('.uid').focus(function () {
        $('.id_box .input_box').addClass('input_focus');
      });
      $('.uid').blur(function () {
        $('.id_box .input_box').removeClass('input_focus');
      });
    });
  }

  onkey(events): any {
    console.log('account Id', this.account.id);
    if (events.target.value.length == 0) {
      this.alreadyId = false;
      this.idChecked = false;
    }
  }

  checkId(type): any {
    this.dbService
      .collection$('student', (ref) =>
        ref.where('id', '==', type).where('exitSwitch', '==', false)
      )
      .pipe(take(1))
      .subscribe(async (e) => {
        if (e[0]) {
          this.alreadyId = true;
          this.idChecked = false;
        } else if (!this.form.controls.id.valid) {
          return;
        } else {
          const dialogRef = this.dialog.open(AlertDesignComponent, {
            // data: 'canId'
            data: { txt: '사용 가능한 아이디입니다.', ok: '사용하기' },
          });

          dialogRef.afterClosed().subscribe((data) => {
            console.log('Data', data.data);
            if (data.data == 'ok') {
              this.idChecked = true;
              this.alreadyId = false;
              this.oneMoreCheckId = type;
            } else if (data.data == 'cancel') {
              this.idChecked = false;
              this.account.id = '';
            }
          });
        }
      });
  }

  save(): any {
    alert('회원가입이 완료되었습니다.');
  }

  // 비밀번호 중복 확인
  matchingPasswords(passwordKey: string, confirmPasswordKey: string): any {
    return (group: FormGroup): { [key: string]: any } => {
      const password = group.controls[passwordKey];
      const confirm_password = group.controls[confirmPasswordKey];

      if (password.value !== confirm_password.value) {
        return {
          mismatchedPasswords: true,
        };
      }
    };
  }

  // 개인정보, 서비스, 마케팅 동의 함수
  checkAgreeeAll(num): any {
    if (this.agreeAllTerms && num === 0) {
      this.account.serviceTerms = true;
      this.account.personalInfo = true;
    } else if (
      num === 0 &&
      this.account.serviceTerms &&
      this.account.personalInfo
    ) {
      this.account.serviceTerms = false;
      this.account.personalInfo = false;
    }

    if (this.account.serviceTerms && this.account.personalInfo && num !== 0) {
      this.agreeAllTerms = true;
    } else if (num !== 0) {
      this.agreeAllTerms = false;
    }
  }

  genderCheck(gender): any {
    this.account.gender = gender.target.value;
  }

  register(): any {
    if (this.oneMoreCheckId == this.account.id) {
      this.spinner.show();

      const registerUser = {
        email: `${this.form.value.id}@gmail.com`,
        password: this.form.value.password,
      };

      this.authService
        .registerUser(registerUser)
        .then((userCredential) => {
          const user = {
            studendId: userCredential.user.uid,
            id: this.form.value.id,
            password: this.form.value.password,
            teacherCode: this.account.teacherCode,
            name: this.account.name,
            gender: this.account.gender,
            region: this.account.region,
            grade: this.account.grade,
            school: this.account.school,
            groupPlaySwitch: this.account.groupPlaySwitch,
            allPlayFeed: this.account.allPlayFeed,
            exitSwitch: this.account.exitSwitch,
            serviceTerms: this.account.serviceTerms,
            personalInfo: this.account.personalInfo,
            type: this.account.type,
          };

          this.authService.updateUserData(user.studendId, user).then((data) => {
            this.spinner.hide();
            const dialogRef = this.dialog.open(AlertDesignOnebuttonComponent, {
              data: { txt: '회원가입이 완료되었습니다.' },
            });

            dialogRef.afterClosed().subscribe((data) => {
              if (data.data == 'ok') {
                this.router.navigate(['/login']);
              }
            })
          });
        })
        .catch((error) => {
          console.log('register Error', error);
        });
    } else {
      return;
    }
  }

  openService() {
    this.router.navigateByUrl(
      this.router.createUrlTree(['/terms'])
    );
  }

  openPersonal(type) {
    this.router.navigateByUrl(`/terms?type=${type}`);
    this.userinfo.updateUserInfo(this.account);
  }

}
